module.exports = __webpack_public_path__ + "img/img_40@2x.756affe7.png";